import { isWeb } from '../utils/platform';

/** Product measurement excludes user-entered text, money amounts and account identifiers. */
export function trackingAllowed(): boolean {
  try { return isWeb() && localStorage.getItem('finflow_tracking_consent') === 'accepted'; }
  catch { return false; }
}
const values: Record<string, readonly string[]> = {
  method: ['email', 'google', 'apple'],
  plan: ['monthly', 'yearly', 'annual'],
  source: ['landing_hero', 'landing_footer', 'login_signup_submit', 'login_signup_focus', 'login_signup', 'manual_setup', 'live_bank_data', 'demo_snapshot', 'unknown', 'skip', 'connect_bank'],
  choice: ['connect_bank', 'demo_snapshot', 'manual_setup', 'skip'],
  funnel: ['activation', 'automatic_monitoring'],
};
export function safeAnalyticsParameters(input: Record<string, unknown> = {}): Record<string, string | number> {
  const output: Record<string, string | number> = {};
  for (const [key, allowed] of Object.entries(values)) {
    if (typeof input[key] === 'string' && allowed.includes(input[key] as string)) output[key === 'source' ? 'ui_source' : key] = input[key] as string;
  }
  if (Number.isInteger(input.step) && Number(input.step) >= 1 && Number(input.step) <= 10) output.step = Number(input.step);
  return output;
}
